import _styled from "styled-components";
import { css } from "styled-components";
import { Container } from "@crehana/ui";
import { jsx as _jsx } from "react/jsx-runtime";
var NavbarContainer = function NavbarContainer(_ref) {
  var className = _ref.className,
    children = _ref.children;
  return /*#__PURE__*/_jsx(_StyledContainer, {
    className: className,
    children: children
  });
};
export default NavbarContainer;
var _StyledContainer = /*#__PURE__*/_styled(Container).withConfig({
  componentId: "sc-ype0cd-0"
})(["\n      ", " {\n        width: calc(100% - 80px);\n      }\n    "], function (props) {
  return props.theme.breakpoints.up('md');
});